/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const PageModeIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <path
        d="M19.2 8.328C19.1875 8.21776 19.1634 8.10916 19.128 8.004V7.896C19.0703 7.77262 18.9933 7.6592 18.9 7.56L11.7 0.36C11.6008 0.266659 11.4874 0.189697 11.364 0.132H11.256L10.872 0H3.6C2.64522 0 1.72955 0.379285 1.05442 1.05442C0.379285 1.72955 0 2.64522 0 3.6V20.4C0 21.3548 0.379285 22.2705 1.05442 22.9456C1.72955 23.6207 2.64522 24 3.6 24H15.6C16.5548 24 17.4705 23.6207 18.1456 22.9456C18.8207 22.2705 19.2 21.3548 19.2 20.4V8.4C19.2 8.4 19.2 8.4 19.2 8.328ZM12 4.092L15.108 7.2H12V4.092ZM16.8 20.4C16.8 20.7183 16.6736 21.0235 16.4485 21.2485C16.2235 21.4736 15.9183 21.6 15.6 21.6H3.6C3.28174 21.6 2.97652 21.4736 2.75147 21.2485C2.52643 21.0235 2.4 20.7183 2.4 20.4V3.6C2.4 3.28174 2.52643 2.97652 2.75147 2.75147C2.97652 2.52643 3.28174 2.4 3.6 2.4H9.6V8.4C9.6 8.71826 9.72643 9.02348 9.95147 9.24853C10.1765 9.47357 10.4817 9.6 10.8 9.6H16.8V20.4Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
